import { useState, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import { apiPost } from '../services/apiClient';

export const ALL_PERSONAS = 'all';

// Converts the page's persona state to the API's filter value.
export const apiPersona = (persona) => (persona && persona !== ALL_PERSONAS ? persona : null);

// Dropdown of the personas configured for a topic's prompt set (from
// llm_prompts_topic_tracker.key_personas, via its own RPC). Most topics have
// none, in which case the control renders nothing — 'All Personas' with no
// alternatives is not a choice. Rendered beside ProductSelector and styled
// identically to it, so the two read as one family of selects.
const LLMPersonaSelector = ({ topicId, value, onChange }) => {
    const [personas, setPersonas] = useState([]);

    useEffect(() => {
        setPersonas([]);
        if (!topicId) return;

        let cancelled = false;
        apiPost('topic/llm-recommendations/personas', { topic_id: topicId })
            .then(r => r.json())
            .then(result => {
                if (!cancelled) {
                    setPersonas((result?.data || []).map(row => row.persona).filter(Boolean));
                }
            })
            .catch(err => console.error('[LLMPersonaSelector] personas error:', err));

        return () => { cancelled = true; };
    }, [topicId]);

    if (personas.length === 0) return null;

    // A stale selection (e.g. left over from another topic) displays as All.
    const effectiveValue = personas.includes(value) ? value : ALL_PERSONAS;

    return (
        <FormControl size="small" variant="outlined" sx={{ minWidth: 150 }}>
            <InputLabel id="llm-persona-select-label">Persona</InputLabel>
            <Select
                labelId="llm-persona-select-label"
                id="llm-persona-select"
                value={effectiveValue}
                label="Persona"
                onChange={(e) => onChange(e.target.value)}
                sx={{
                    '& .MuiSelect-select': {
                        backgroundColor: 'white',
                        paddingRight: '32px !important'
                    }
                }}
            >
                <MenuItem value={ALL_PERSONAS}>All Personas</MenuItem>
                {personas.map(p => (
                    <MenuItem key={p} value={p}>{p}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default LLMPersonaSelector;
